module.exports = __webpack_public_path__ + "img/m.919d8636.jpg";